import { render, staticRenderFns } from "./producto_mas_vendido.vue?vue&type=template&id=22150fe2"
import script from "./producto_mas_vendido.vue?vue&type=script&lang=js"
export * from "./producto_mas_vendido.vue?vue&type=script&lang=js"
import style0 from "./producto_mas_vendido.vue?vue&type=style&index=0&id=22150fe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports